export class AccionistaGeneral {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            tipo_juridico: {
                value: null,
                header: 'Tipo de Persona Juridica:',
                required: 'Tipo de Persona Juridica es requerido',
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            fecha: {
                value: new Date(),
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
            },
            pais: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerida'
            },
            compania: {
                value: '',
                header: 'Compañía:',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Compañía es requerida',
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            grupo_empresarial: {
                value: null,
                header: 'Agrupa para grupo empresarial:',
                required: 'Seleccione',
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            tipo_formulario: {
                value: null,
                header: 'Tipo de formulario:',
                required: 'Tipo de formulario es requerido'
            },
            fecha_ingreso: {
                value: null,
                header: 'FECHA DE INGRESO A LA COMPAÑÍA:',
                required: 'Fecha de ingreso a la compañía es requerido'
            },
            tipo_identificacion_pn: {
                value: null,
                header: 'Tipo de identificación:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Tipo de documento:',
                    FRM_DIFARE: 'Tipo de documento:',
                },
                required: 'Tipo de formulario es requerido'
            },
            apellidos_dp: {
                value: '',
                header: 'Apellidos completos:',
                required: 'Apellidos son requeridos',
                maxLength: 'Máximo 500 caracteres'
            },
            nombres_dp: {
                value: '',
                header: 'Nombres completos:',
                required: 'Nombre es requerido',
                maxLength: 'Máximo 500 caracteres'
            },
            identificacion: {
                value: '',
                header: 'No. doc. Identidad:',
                required: 'No. RUC / Identificación tributaria es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            nacionalidad: {
                value: null,
                header: 'Nacionalidad:',
                required: ' Buscar por nacionalidad'
            },
            genero: {
                value: null,
                header: 'Género:',
                required: 'Género es requerido'
            },
            fecha_nacimiento: {
                value: null,
                header: 'Fecha de nacimiento (día/mes/año):',
                headerPorTipo: {
                    FRM_TOYOTA: 'Fecha de nacimiento:',
                    FRM_DIFARE: 'Fecha de nacimiento:',
                },
                required: 'Fecha inicioes de actividad'
            },
            direccion: {
                value: '',
                header: 'Calle Principal No. y Calle Secundaria:',
                required: 'Dirección domicilio es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4
            },
            pais_dp: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia_dp: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad_dp: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton_dp: {
                value: '',
                header: 'Ciudad',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerido'
            },
            tiempo_reside_extranjero: {
                value: '',
                header: 'Tiempo que reside en el Ecuador (Si es extranjero):',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Tiempo es requerido'
            },
            email: {
                value: '',
                header: 'Correo electrónico personal:',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Correo electrónico es requerido'
            },
            telefono_celular: {
                value: '',
                header: 'No. Celular:',
                required: 'No. Celular es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            telefono_domicilio: {
                value: '',
                header: 'No. de teléfono del domicilio:',
                required: 'No. de teléfono del domicilio es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            estado_civil: {
                value: null,
                header: 'Estado civil:',
                required: 'Estado civil es requerido'
            },
            separacion_bien: {
                value: null,
                header: 'Separación de bienes:',
                required: 'Separación de bienes es requerido',
                table: false,
                tablePorTipo: {
                    FRM_TOYOTA: true,
                }
            },
            apellidos_ec: {
                value: '',
                header: 'Apellidos completos:',
                required: 'Apellido es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            nombres_ec: {
                value: '',
                header: 'Nombres completos:',
                required: 'Nombre es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            tipo_identificacion_ec: {
                value: null,
                header: 'Tipo de documento:',
                required: 'Tipo identificación es requerido'
            },
            identificacion_ec: {
                value: '',
                header: 'No. doc. Identidad:',
                required: 'No. RUC / Identificación tributaria es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            nacionalidad_ec: {
                value: null,
                header: 'Nacionalidad:',
                required: 'Nacionalidad es requerido'
            },
            genero_cy: {
                value: null,
                header: 'Género:',
                required: 'Género es requerido'
            },
            fecha_nacimiento_ec: {
                value: new Date(),
                header: 'Fecha Nacimiento (día/mes/año):',
                headerPorTipo: {
                    FRM_TOYOTA: 'Fecha de nacimiento:',
                    FRM_DIFARE: 'Fecha de nacimiento:',
                },
                required: 'Fecha de nacimiento es requerido'
            },
            lugar_trabajo_ec: {
                value: '',
                header: 'Nombre del lugar de trabajo:',
                required: 'Campo es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            cargo_ec: {
                value: '',
                header: 'Cargo:',
                required: 'Cargo es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            actividad_economica: {
                value: null,
                header: 'Actividad Económica:',
                required: 'Actividad Económica es requerido'
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
    pattern = { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Correo no válido. E.g. example@email.com' };
    optionLabel = 'nombre';
}
